import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/USOBConfig";


import {
  usobModelsLoading,
  submitUsobModelsActionDispatcher,
  submitUsobModelsErrorDispatcher,
  SUBMIT_USOBMODELS_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postUsobModelsAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.get("/model-no");
  return result;
};

function* submitUsobModelsSaga({ postData }) {
  try {
    yield put(usobModelsLoading(true));
    const data = yield call(postUsobModelsAPI);
    yield put(submitUsobModelsActionDispatcher(data));
    yield put(submitUsobModelsErrorDispatcher({}));
    yield put(usobModelsLoading(false));
  } catch (e) {
    yield put(submitUsobModelsActionDispatcher({}));
    yield put(submitUsobModelsErrorDispatcher(e.response.data));
    yield put(usobModelsLoading(false));
  }
}

function* submitUsobModelsWatcher() {
  yield takeEvery(SUBMIT_USOBMODELS_ACTION_REQUESTED, submitUsobModelsSaga);
}
export default submitUsobModelsWatcher;
